import { RefObject, useCallback, useEffect, useState } from "react";
import { RouteComponentProps, useLocation } from "react-router";
import {
  DynamicModalContent,
} from "../../contenful/types";
import { PATH } from "./UserModalController";


export interface PathProps extends Partial<RouteComponentProps> {
  path: { type?: PATH; modal?: string; mode?: string } | undefined;
  options?: { verification: boolean, newUser: boolean}
}

export const isHomeScreen = () => window.location.pathname.split("/").slice(-1)[0] === PATH.MODE

export const setModalPath = ({ path, history, options }: PathProps) => {
  let pathOption;
  pathOption = isHomeScreen() ? {...path, mode: PATH.MODE} : path
  //console.log("SetMODAL => Regulare", path, options);
  if(options && options.verification){
    if(isHomeScreen()){
      //console.log("SetMODAL => ishomescreen")
      pathOption = {type: PATH.VERIFY_EMAIL, modal: options.newUser ? PATH.NEW_USER : PATH.MODAL_TYPE, mode: PATH.MODE }
    } else {
      //console.log("SetMODAL => is not homescreen")
      pathOption = {type: PATH.VERIFY_EMAIL, modal: options.newUser ? PATH.NEW_USER : PATH.MODAL_TYPE }
    }
  }

  if (history) {
    history.push({
      search:
        path !== undefined ? new URLSearchParams(pathOption).toString() : "",
    });
  }
};


enum MouseDown {
  DOWN_REF,
  DEFAULT,
}
export function useClickOutside<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T>,
  callback: () => void
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}

export const getDynamicContentByType = ( modalContent: DynamicModalContent[], type: PATH ): Partial<DynamicModalContent> => {
  let targetContent = {};
  if (modalContent) {
    modalContent.forEach((content) => {
      if (content.modalType?.includes(type) ?? false) {
        targetContent = content;
      }
    });
  }
  return targetContent;
};

export const hasContent = (modalContent: DynamicModalContent[], type: PATH) => {
  let isActive = false;
  if (modalContent) {
    if (getDynamicContentByType(modalContent, type).active) {
      isActive = true;
    }
  }
  return isActive;
};

export const getPathType = (str: string) => {
  const searchParam = new URLSearchParams(str);
  const type = searchParam.get('type');
  return type
};

export const useGetQueryParamValues = (params: Array<string>) => {
  const location = useLocation();

  return useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    return params.map((param) => searchParams.get(param));
  }, [location.search, params]);
};